<ng-sidebar-container>
  <ng-sidebar *ngIf="sideBarShow" [(opened)]="sideBarOpen" position="right" [animate]="sideBarAnimate" [keyClose]="false">
    <div class="sidebar-fix" >

      <div *ngIf="selected!=null">
        <div class="sidebar header-spacing"></div>

        <nb-card>
          <nb-card-body>
            <ngx-form-entry title="Customer" [value]="selected.business?.name" ></ngx-form-entry>


            <div *ngIf="selected.content != null">
              <nb-card-body>
                <ngx-form-entry title="Title" [value]="selected.title"></ngx-form-entry>
                <ngx-form-entry title="Location" [value]="selected.location"></ngx-form-entry>
                <ngx-form-entry title="Date" [value]="selected.date | date:'yyyy-MM-dd'"></ngx-form-entry>
                <ngx-form-entry *ngIf="selected.dateTo" title="Date To" [value]="selected.dateTo | date:'yyyy-MM-dd'"></ngx-form-entry>

                <ngx-form-entry title="Summary" [value]="selected.purpose"></ngx-form-entry>
                <!-- <ngx-form-upload *ngIf="(selected?.content?.type == ActivityContentType.VisitReport || selected?.content?.type == ActivityContentType.Note)" title="Files" url="/api/v1/upload" [(files)]="selected.files" [hideUpload]="true"></ngx-form-upload> -->
                <ngx-form-upload title="Files" url="/api/v1/upload" [(files)]="selected.files" [hideUpload]="true"></ngx-form-upload>
                <ngx-form-upload title="Pdfs" url="/api/v1/upload" [(files)]="selected.pdfs" [hideUpload]="true" [hideCheckbox]="false"></ngx-form-upload>
                <ngx-form-participant title="Participants" [(value)]="selected.participants" [edit]="false"></ngx-form-participant>
              </nb-card-body>
            </div>
          </nb-card-body>
        </nb-card>

        <div *ngIf="selected?.content?.type == ActivityContentType.VisitReport 
            || selected?.content?.type == ActivityContentType.Note
            || selected?.content?.type == ActivityContentType.OnlineMeeting
            || selected?.content?.type == ActivityContentType.TradeShowMeeting
            || selected?.content?.type == ActivityContentType.OnSiteMeeting
          ">
          <div *ngFor="let bu of businessUnits">
            <nb-card *ngIf="filterBusinessUnits(selected, $any(selected?.content)?.topics, bu._id)?.length != 0">
              <nb-card-header><h4>{{bu.name}}</h4></nb-card-header>
              <nb-card-body>
                <label *ngIf="filterBusinessUnits(selected, $any(selected?.content)?.topics, bu._id)?.length == 0">No topics found!</label>
                <table class="table table-hover table-bordered" *ngIf="filterBusinessUnits(selected, $any(selected?.content)?.topics, bu._id)?.length > 0">
                  <tr><th>Project</th><th>Topic</th><th>Action/Description</th><th>Action plan, responsible person</th></tr>
                  <tr *ngFor="let t of filterBusinessUnits(selected, $any(selected?.content)?.topics, bu._id)">
                    <td>{{getProjectName(selected, t.project)}}</td>
                    <td>{{t.topic}}</td>
                    <td>{{t.action}}</td>
                    <td>
                      <div *ngFor="let item of t.plan" [class.completed]="item.completed">
                        <i class="ion-person"></i>&nbsp;{{item.name}}&nbsp;
                        <i class="ion-information-circled"></i>&nbsp;{{item.action}}&nbsp;
                        <i class="ion-calendar"></i>&nbsp;{{item.date | date:'dd. MM. yyyy'}}
                      </div>
                    </td>
                  </tr>
                </table>
              </nb-card-body>
            </nb-card>
          </div>
        </div>

        <div *ngIf="selected?.content?.type == ActivityContentType.QuickNote">

        </div>
      </div>
      <div class="sidebar header-spacing"></div>

      <div class="sidebar header">
        <h1>{{getActivityType(selected?.content?.type)}} - {{selected?.title}}
          <a *ngIf="(selected?.content?.type == ActivityContentType.VisitReport
          || selected?.content?.type == ActivityContentType.OnlineMeeting
          || selected?.content?.type == ActivityContentType.TradeShowMeeting
          || selected?.content?.type == ActivityContentType.OnSiteMeeting
          ) && selected._id != null" [routerLink]="[]" (click)="openVR(selected)">
            <i class="ion-document-text"></i>
          </a>
        </h1>

      </div>
      <div class="sidebar footer">
        <div *ngIf="!isPreview" class="row"  style="display:flex;align-items:center;justify-content:center;">
          <!-- <div class="col-md-4"></div>
          <div class="col-md-8"> -->
            <button class="btn btn-default btn-sm" (click)="cancel()" >Close</button>
            <button *ngIf="canEdit()" class="btn btn-primary btn-md" (click)="edit()">Edit</button>
            <button *ngIf="canEdit() && !this.selected.draft" class="btn btn-primary btn-md" (click)="edit(true)">New version</button>
            <!-- <button *ngIf="!isNoteOrVR() && showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">ZIP attachments</button> -->
            <!-- <button *ngIf="isNoteOrVR()" class="btn btn-info btn-md" (click)="isPreview=true">Download</button> -->
            <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.preview)">Preview</button>
            <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document)">Document</button>
            <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipMerged)">ZIP (document & attachments)</button>
            <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">{{isNoteOrVRorOM() ? 'ZIP (attachments only)' : 'ZIP attachments'}}</button>
            <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.pdfAndZip)">PDF & ZIP</button>
            <!-- </div> -->
        </div>
        <!-- <div *ngIf="isPreview" class="row" style="display:flex;align-items:center;justify-content:center;">
          <button class="btn btn-default btn-md" (click)="isPreview=false">Back</button>
          <button class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.document)">Document</button>
          <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.merged)">Merge document with attachments</button>
          <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipMerged)">ZIP (document & attachments)</button>
          <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.zipAttachments)">{{isNoteOrVR() ? 'ZIP (attachments only)' : 'ZIP attachments'}}</button>
          <button *ngIf="showMergeOrZipButton()" class="btn btn-info btn-md" (click)="pdfPreview(selected, downloadType.pdfAndZip)">PDF & ZIP</button>
        </div> -->

      </div>
      <div *ngIf="selected==null"><label>Nothing selected</label></div>
    </div>
  </ng-sidebar>

  <div ng-sidebar-content>
    <ngx-page-container>

      <h1>News</h1>
      <ngx-search [(value)]="search"></ngx-search>
      <!--[participants]="populateParticipants(n)"-->
      <!--[customer]="populateCustomer(n)"-->
      <!--[user]="populateOwner(n)"-->
      <!--<div infiniteScroll-->
      <ngx-news-entry
        *ngFor="let n of filter(search, news | async)"
      [activity]="n"
      (show)="toggleSidebarView($event)"
      ></ngx-news-entry>
    </ngx-page-container>
  </div>
</ng-sidebar-container>
